import React from 'react';
import ReactDOM from 'react-dom';
import noUiSlider from 'nouislider';

// Main CSS: ui-components/slider.less
// Slider CSS: nouislider.min.less

export default class Slider extends React.Component {
	constructor(props) {
		super(props);

		this.sliderChangeHandler = this.sliderChangeHandler.bind(this);
		this.sliderSlideHandler = this.sliderSlideHandler.bind(this);
	}

	componentDidMount() {
		var sliderStart = this.props.start ? this.props.start : this.props.rangeMin && this.props.rangeMax ? [this.props.rangeMin, this.props.rangeMax] : [0, 10];
		var months = [
			'janúar',
			'febrúar',
			'mars',
			'apríl',
			'maí',
			'júní',
			'júlí',
			'ágúst',
			'september',
			'október',
			'nóvember',
			'desember'
		];

		this.slider = noUiSlider.create(this.refs.sliderContainer, {
			start: sliderStart,
			behaviour: this.props.behaviour || 'drag',
			connect: true,
			tooltips: this.props.tooltips || true,
			/*
			format: this.props.format || {
				to: function (value) {
					console.log(value)
					return value;
				}.bind(this),
				from: function (value) {
					return months[Math.ceil(value)];
				}.bind(this)
			},
			*/
			pips: {
		        mode: 'count',
				values: 12,
        		density: 10,
		        format: {
					to: function (value) {
						return months[Math.round(value)-1];
					}.bind(this),
					from: function (value) {
						return months.indexOf(value)-1;
					}.bind(this)
				}
		    },
			range: !isNaN(this.props.rangeMin) && !isNaN(this.props.rangeMax) && this.props.rangeMin < this.props.rangeMax ? {
				min: this.props.rangeMin,
				max: this.props.rangeMax
			} : {
				min: 0,
				max: 10
			}
		});

		this.slider.on('change', this.sliderChangeHandler)
		this.slider.on('set', this.sliderChangeHandler)
		this.slider.on('slide', this.sliderSlideHandler)
	}

	componentWillReceiveProps(props) {
		if (props.enabled && props.enabled == true) {
			this.refs.sliderContainer.removeAttribute('disabled');
		}
		else if (props.enabled == false) {
			this.refs.sliderContainer.setAttribute('disabled', true);
		}
		if (props.start && props.start != this.slider.options.start) {
			this.slider.set(props.start, false)
		}

		if ((!isNaN(props.rangeMin) && !isNaN(props.rangeMax)) && (props.rangeMin != this.slider.options.range.min || props.rangeMax != this.slider.options.range.max) && props.rangeMin < props.rangeMax) {
			var range = {
				min: Number(props.rangeMin),
				max: Number(props.rangeMax)
			};
			this.slider.updateOptions({
				range: range,
				start: props.start || [range.min, range.max]
			});
		}
	}

	sliderChangeHandler(event) {
		this.value = event;

		if (this.props.onChange) {
			console.log(event)
			this.props.onChange({
				target: {
					name: this.props.inputName || '',
					type: 'slider',
					value: event
				}
			});
		}
	}

	set(value) {
		this.slider.set(value, false);
	}

	sliderSlideHandler(event) {
		if (this.props.onSlide) {
			this.props.onSlide({
				target: {
					name: this.props.inputName || '',
					type: 'slider',
					value: event
				}
			});
		}
	}

	render() {
		return <div className={'slider-container'+(this.props.className ? ' '+this.props.className : '')}>
			<div ref="sliderContainer"></div>
			{
				this.props.children
			}
		</div>;
	}
}
